import React, { Component } from 'react'
import Autocomplete         from 'react-autocomplete'
import styles               from './HotelSearchInputPlace.module.css'
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome'

import {withTranslation} from 'react-i18next'

import { resultTypeZone,  resultTypeHotel} from "./../../utility/constants"


const seachUrlByTerm = term => `/core/search-zone-and-hotel?take=10&includeHotels=false&term=${encodeURIComponent(term)}`
const SEARCH_DEBOUNCE_MS = 200
const MIN_SEARCH_TERM_LENGTH = 2
const SEARCH_CACHE_LIMIT = 50

const getSelectedItemName = item => item ? (item.name || item.Name || '') : ''
const getSearchCacheKey = term => term.trim().toLowerCase()

// este componente se connecta a la API de canarias.com para encortrar terminos  buscado
// le pasa el temino e recibe 2 tipos de resutlados: hoteles o destinos, que mostreran agrupados por tipo

export class HotelSearchInputPlace extends Component {
  constructor(props){
    super(props)

    this.state = {
        term:        getSelectedItemName(props.selectedItem),
        loading:     false,
        results:     props.results || [] 
    }

    this.requestTimer    = null
    this.activeRequest   = null
    this.requestSequence = 0
    this.resultsCache    = new Map()
    this.doSearch        = this.doSearch.bind(this)
    this.handleOnSelect  = this.handleOnSelect.bind(this)
    this.handleOnChange  = this.handleOnChange.bind(this)
    this.renderItem      = this.renderItem.bind(this)
    this.renderMenu      = this.renderMenu.bind(this)
    this.receivedResults = this.receivedResults.bind(this)

  }

  componentWillUnmount(){
    clearTimeout(this.requestTimer)
    this.requestSequence++
    this.abortActiveRequest()
  }

  abortActiveRequest = () => {
      if(this.activeRequest){
        this.activeRequest.abort()
        this.activeRequest = null
      }
  }

  getCachedResults = cacheKey => {
      if(!this.resultsCache.has(cacheKey)) return null

      const cachedResults = this.resultsCache.get(cacheKey)
      this.resultsCache.delete(cacheKey)
      this.resultsCache.set(cacheKey, cachedResults)
      return cachedResults
  }

  cacheResults = (cacheKey, data) => {
      if(this.resultsCache.has(cacheKey)) this.resultsCache.delete(cacheKey)
      this.resultsCache.set(cacheKey, data)

      if(this.resultsCache.size > SEARCH_CACHE_LIMIT){
        const oldestKey = this.resultsCache.keys().next().value
        this.resultsCache.delete(oldestKey)
      }
  }

   doSearch = (searchedTerm, requestSequence) => {
      const cacheKey = getSearchCacheKey(searchedTerm)
      const requestController = typeof AbortController !== 'undefined' ? new AbortController() : null
      this.activeRequest = requestController

      fetch(seachUrlByTerm(searchedTerm), requestController ? { signal: requestController.signal } : {})
        .then(response => {
          if(!response.ok) throw new Error(`Zone search failed with status ${response.status}`)
          return response.json()
        })
        .then(data => {
          if(requestSequence !== this.requestSequence) return

          this.activeRequest = null
          this.cacheResults(cacheKey, data || [])
          this.receivedResults(data, requestSequence)
        })
        .catch(error => {
          if(requestSequence !== this.requestSequence) return

          this.activeRequest = null
          if(error && error.name === 'AbortError') return
          this.setState({ results: [], loading: false })
        })
  }

  receivedResults = (data, requestSequence) => {
      if(requestSequence !== this.requestSequence) return

      if(!data || data.length < 1){
        this.setState({ results: [], loading: false })
        return
      }

      // en los resultados hoteles y destino son mezclados, el buscador los muestras agrupados por tipo
      const zones  = data.filter(item => item.type === resultTypeZone)
      const hotels = data.filter(item => item.type === resultTypeHotel)

      let results = []
      if(zones.length > 0){
        results.push({header: this.props.t("search_box.place")})
        results = results.concat(zones)
      }
      if(hotels.length > 0){
        results.push({header: this.props.t("search_box.hotels")})
        results = results.concat(hotels)
      }

      data && this.setState({ results, loading: false})
  }

  handleOnSelect = (value, item) => {
    clearTimeout(this.requestTimer)
    this.requestSequence++
    this.abortActiveRequest()
    this.setState({ term: value, loading: false, results: [] })
    this.props.onSelected(item)
  }

  handleOnChange = (event, value) => {
    clearTimeout(this.requestTimer)
    this.abortActiveRequest()
    this.requestSequence++
    this.props.onSelected(null)

    const searchedTerm = value.trim()
    if(searchedTerm.length < MIN_SEARCH_TERM_LENGTH){
      this.setState({term: value, loading: false, results: []})
      return
    }

    const requestSequence = this.requestSequence
    const cachedResults = this.getCachedResults(getSearchCacheKey(searchedTerm))
    if(cachedResults !== null){
      this.setState({term: value, loading: false, results: []}, () => this.receivedResults(cachedResults, requestSequence))
      return
    }

    this.setState({term: value, loading: true, results: []})
    this.requestTimer = setTimeout(() => {
      this.requestTimer = null
      this.doSearch(searchedTerm, requestSequence)
    }, SEARCH_DEBOUNCE_MS)
  }

  renderItem = (item, isHighlighted) => 
    item ? 
    (item.header
        ? <div className={`${styles.item} ${styles.itemHeader}`}  key={item.header}>
            {item.header}
          </div>
        : <div className={`${styles.item} ${isHighlighted ? styles.itemHighlighted : ''}`} key={item.code}>
            {item.name}
          </div>
    ) : null
  

  renderMenu = (items, value) => 
      <div className={styles.menu}>
          {  value === ''       ? null
           : this.state.loading ? items
           : items.length === 0 ? null
           : items
          }
      </div>

        
  renderIcons = () => this.state.loading ? <FontAwesomeIcon icon="sync" className={styles.iconSync} /> : null

  render() {
    return (
      <div className={this.props.horizontal != "true" ? styles.lineWrapper : styles.lineWrapperHorizontal}>
        {this.props.showLabel && <div className={this.props.horizontal != "true" ? styles.label : styles.labelHorizontal}>{this.props.t("search_box.label_place")}</div>}        
        <div className={this.props.horizontal != "true" ? styles.inputContainer : styles.inputContainerHorizontal}>
          <Autocomplete value={this.state.term}
                        items={this.state.results}
                        getItemValue={item => item.name}
                        onSelect={this.handleOnSelect}
                        onChange={this.handleOnChange}
                        renderItem={this.renderItem}
                        renderMenu={this.renderMenu}
                        isItemSelectable={item => item && !(item.header)}
                        inputProps={{className: this.props.horizontal != "true" ? styles.input : styles.inputHorizontal, placeholder: this.props.placeholder, id: 'states-autocomplete', autoComplete: 'off', 'aria-busy': this.state.loading}}
                        wrapperProps={{className: this.props.horizontal != "true" ? styles.inputWrapper : styles.inputWrapperHorizontal}}
          />
         {this.renderIcons()}
        </div>
      </div>
    )
  }
}

export default withTranslation()(HotelSearchInputPlace)





